<mat-sidenav-container fullscreen>
  <mat-sidenav #sidenav [opened]="menuOpened" (closedStart)="onMenuClosed();" mode="over">
    <app-menu></app-menu>
  </mat-sidenav>

  <mat-sidenav-content>

    <app-loading-bar [ngClass.gt-sm]="{ desktop: true }"></app-loading-bar>

    <!-- main content goes here -->
    <router-outlet></router-outlet>

  </mat-sidenav-content>
</mat-sidenav-container>
